import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { EventService } from "../event-service/event.service";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class GroupService {
  constructor(private eventService: EventService, private http: HttpClient) {}

  public query(params: any) {
    let projectId;
    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/groups`;
    return this.http.get(url, { params });
  }

  public get(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}`;
    return this.http.get(url, { params }).pipe(map((data: any) => data.group));
  }

  public resolve(group: any) {
    const url = `/api/v4/projects/${group.projectId}/groups/${group.id}/resolved`;
    const [params] = splayParams();

    return this.http.put(url, null, { params }).pipe(
      map(() => {
        group.resolved = true;
        this.eventService.publish("group:resolved", group);
        return group;
      }),
    );
  }

  public unresolve(group: any) {
    const url = `/api/v4/projects/${group.projectId}/groups/${group.id}/unresolved`;
    const [params] = splayParams();

    return this.http.put(url, null, { params }).pipe(
      map(() => {
        group.resolved = false;
        this.eventService.publish("group:resolved", group);
        return group;
      }),
    );
  }

  public mute(group: any) {
    const url = `/api/v4/projects/${group.projectId}/groups/${group.id}/muted`;

    return this.http.put(url, null).pipe(
      map(() => {
        group.muted = true;
        this.eventService.publish("group:muted", group);
        return group;
      }),
    );
  }

  public unmute(group: any) {
    const url = `/api/v4/projects/${group.projectId}/groups/${group.id}/unmuted`;

    return this.http.put(url, null).pipe(
      map(() => {
        group.muted = false;
        this.eventService.publish("group:unmuted", group);
        return group;
      }),
    );
  }

  public resolveMultiple(groups: any) {
    let group;
    const url = `/api/v4/projects/${groups[0].projectId}/groups/resolved`;
    const [params] = splayParams();
    const ids = (() => {
      const result = [];
      for (group of groups) {
        result.push(group.id);
      }
      return result;
    })();

    return this.http.put(url, { ids }, { params }).pipe(
      map(() => {
        for (group of groups) {
          group.resolved = true;
          this.eventService.publish("group:resolved", group);
        }
        return groups;
      }),
    );
  }

  public unresolveMultiple(groups: any) {
    let group;
    const url = `/api/v4/projects/${groups[0].projectId}/groups/unresolved`;
    const [params] = splayParams();
    const ids = (() => {
      const result = [];
      for (group of groups) {
        result.push(group.id);
      }
      return result;
    })();

    return this.http.put(url, { ids }, { params }).pipe(
      map(() => {
        for (group of groups) {
          group.resolved = false;
          this.eventService.publish("group:resolved", group);
        }
        return groups;
      }),
    );
  }

  public muteMultiple(groups: any) {
    let group;
    const url = `/api/v4/projects/${groups[0].projectId}/groups/muted`;
    const ids = (() => {
      const result = [];
      for (group of groups) {
        result.push(group.id);
      }
      return result;
    })();

    return this.http.put(url, { ids }).pipe(
      map(() => {
        for (group of groups) {
          group.muted = true;
          this.eventService.publish("group:muted", group);
        }
        return groups;
      }),
    );
  }

  public unmuteMultiple(groups: any) {
    let group;
    const url = `/api/v4/projects/${groups[0].projectId}/groups/unmuted`;
    const ids = (() => {
      const result = [];
      for (group of groups) {
        result.push(group.id);
      }
      return result;
    })();

    return this.http.put(url, { ids }).pipe(
      map(() => {
        for (group of groups) {
          group.muted = false;
          this.eventService.publish("group:muted", group);
        }
        return groups;
      }),
    );
  }

  public delete(group: any) {
    const url = `/api/v4/projects/${group.projectId}/groups/${group.id}`;
    return this.http.delete(url);
  }
}
